import types from '../../constants';

const initialState = {
  loading: false,
  loadingCompanies: false,
  data: {
    company: '',
    level: 'admin',
  },
  companies: [],
  isEdit: false,
  errors: {},
};

const UserReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case types.USER_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case types.USER_COMPANIES_LOADING_START:
      return {
        ...state,
        loadingCompanies: true,
      };
    case types.USER_COMPANIES_LOADING_END:
      return {
        ...state,
        loadingCompanies: false,
      };
    case types.USER_CLEAR:
      return {
        ...state,
        data: initialState.data,
      };
    case types.USER_FETCH:
      return {
        ...state,
        data: action.payload,
      };
    case types.USER_COMPANIES_FETCH:
      return {
        ...state,
        companies: action.payload,
      };
    case types.USER_SET_IS_EDIT:
      return {
        ...state,
        isEdit: action.payload,
      };
    case types.USER_CHANGE_FORM:
      const newState = {
        ...state,
      };

      newState.data = { ...state.data };
      newState.data[action.payload.field] = action.payload.value;

      return newState;
    case types.USER_SET_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default UserReducers;
